import { render, staticRenderFns } from "./Principle.vue?vue&type=template&id=55259b53&scoped=true&"
import script from "./Principle.vue?vue&type=script&lang=js&"
export * from "./Principle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55259b53",
  null
  
)

export default component.exports